import React, { useContext, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Login from './Pages/Login/Login';

import './App.css';
import Main from './Pages/Main/Main';
import AuthContext from './store/auth-context';
import { Loader } from './Template/components/UI/Modal/Spinner';
import Ticket from './Pages/Podesavanja/Ticket';
import { Toaster } from 'react-hot-toast';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './i18n';
import useNetworkStatus from './Template/hooks/useNetworkStatus';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ChatPage from './Chat/ChatPage';
import ChatWidget from './ChatButton';

// fallback loader za prikaz prilikom prelaska izmedju stranica
const loading = () => (
  <div
    style={{
      position: 'fixed',
      width: '100%',
      height: '100%',
      display: 'grid',
      placeItems: 'center',
    }}
  >
    <Loader />
  </div>
);

const offline = () => (
  <div
    style={{
      position: 'fixed',
      width: '100%',
      height: 'calc(100vh + 20px)',
      display: 'grid',
      placeItems: 'center',
      color: 'white',
      backgroundColor: '#808080c9',
      zIndex: '4000',
      top: '-20px',
    }}
  >
    OFFLINE
  </div>
);
// const online = () => (
//   <div
//     style={{
//       position: 'fixed',
//       width: '100%',
//       height: '100%',
//       display: 'grid',
//       placeItems: 'center',
//       color: 'white',
//       backgroundColor: '#808080c9',
//       zIndex: '3000',
//     }}
//   >
//     ONLINE
//   </div>
// );
// komponente koje se ucitavaju preko react lazy-a jer nije potrebno da se downloaduju u startu sa ostalim komponentama
const Page404 = React.lazy(() => import('./Pages/Page404/Page404'));
const PromenaLozinke = React.lazy(() =>
  import('./Pages/Podesavanja/PromenaLozinke'),
);
const Podrska = React.lazy(() => import('./Pages/Podesavanja/Podrska'));
const Profil = React.lazy(() => import('./Pages/Podesavanja/Profil'));

function App() {
  const { isOnline } = useNetworkStatus();
  const { isLoggedIn } = useContext(AuthContext);
  console.log('NETWORK STATUS', isOnline);
  return (
    <div className="App">
      {isOnline ? null : offline()}
      <Suspense fallback={loading()}>
        <Routes>
          {!isLoggedIn && <Route path="login" element={<Login />} />}
          {isLoggedIn && <Route path="/" element={<Main />} />}
          {isLoggedIn && (
            <Route path="promena-podataka" element={<PromenaLozinke />} />
          )}
          {isLoggedIn && <Route path="podrska" element={<Podrska />} />}
          {isLoggedIn && <Route path="ticket" element={<Ticket />} />}
          {isLoggedIn && <Route path="profil" element={<Profil />} />}

          {/* Potrebno da bude na poslednjem mestu kao poslenja ruta */}
          <Route
            path="*"
            element={!isLoggedIn ? <Navigate replace to="login" /> : <Main />}
          />
          {isLoggedIn && <Route path="*" element={<Page404 />} />}
        </Routes>
        {/* {isLoggedIn && <ChatWidget />} */}
        <Toaster position="top-right" reverseOrder={false} />
      </Suspense>
    </div>
  );
}

export default App;
